import React from 'react';
import {Route, Routes} from "react-router-dom";
import InboxList from "./InboxList";


function InboxRouter() {

    return (
        <Routes>
            <Route path="" element={<InboxList />} />
        </Routes>
    )
}


export default function Inbox() {
    return (
        <InboxRouter />
    )
}

